/**
 * An airline-facing amount in USD major units (`operator-bff:airline-money@v2`), formatted
 * whole like the rest of the PNR drawer. `null` (the price is not available — no price card)
 * yields `null` so the caller shows «No disponible», never a number.
 */
export function formatPriceUsd(amount: number | null | undefined): string | null {
  if (typeof amount !== 'number' || !Number.isFinite(amount)) return null;
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(amount);
  } catch {
    return `${Math.round(amount).toLocaleString()} USD`;
  }
}
